import {
  useTranslate,
  IResourceComponentsProps,
  useMany,
  useNavigation,
} from "@pankod/refine-core";
import {
  List,
  Table,
  TextField,
  useTable,
  getDefaultSortOrder,
  Space,
  EditButton,
  DeleteButton,
  Button,
} from "@pankod/refine-antd";
import { IAgenda } from "interfaces";

export const AgendaList: React.FC<IResourceComponentsProps> = () => {
  const t = useTranslate();
  const { create } = useNavigation()

  const { tableProps, sorter } = useTable<IAgenda>({
    initialSorter: [
      {
        field: "id",
        order: "desc",
      },
    ],
  });

  return (
    <List
      title={t("menu.agendas")}
      pageHeaderProps={{
        extra: [
          <Button key="page_header_extra_1" onClick={() => create(t("menu.agendas"))}>+</Button>,
        ],
      }}

    >
      <Table {...tableProps} rowKey="id">
        <Table.Column
          dataIndex="name"
          key="name"
          title={t("agendas.agenda")}
          render={(value) => <TextField value={value} />}
          defaultSortOrder={getDefaultSortOrder("agenda", sorter)}
          sorter
        />

        <Table.Column<IAgenda>
          title={t("table.actions")}
          dataIndex="actions"
          render={(_, record) => (
            <Space>
              <EditButton hideText size="small" recordItemId={record.id} />
              <DeleteButton hideText size="small" recordItemId={record.id} />
            </Space>
          )}
        />
      </Table>
    </List>
  );
};
